import React from 'react';

const Money = () => {
  return (
    <svg
      width='169'
      height='168'
      viewBox='0 0 169 168'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M84.9525 0C38.565 0 0.952515 37.6125 0.952515 84C0.952515 130.387 38.565 168 84.9525 168C131.34 168 168.953 130.387 168.953 84C168.953 37.6125 131.34 0 84.9525 0ZM89.1338 124.725L89.1713 130.669C89.1713 131.494 88.4963 132.188 87.6713 132.188H82.3463C81.5213 132.188 80.8463 131.512 80.8463 130.688V124.8C64.1963 123.562 56.3588 114.075 55.515 103.763C55.44 102.881 56.1338 102.131 57.015 102.131H65.6775C66.4088 102.131 67.0463 102.656 67.1588 103.369C68.115 109.312 72.7463 113.756 81.0525 114.862V88.1063L76.4213 86.925C66.615 84.5812 57.2775 78.4688 57.2775 65.7937C57.2775 52.125 67.665 44.775 80.94 43.4812V37.2937C80.94 36.4688 81.615 35.7937 82.44 35.7937H87.7088C88.5338 35.7937 89.2088 36.4688 89.2088 37.2937V43.425C102.053 44.7188 111.69 52.2187 112.815 63.9C112.909 64.7812 112.215 65.55 111.315 65.55H102.896C102.146 65.55 101.509 64.9875 101.415 64.2563C100.665 58.7813 96.2775 54.3187 89.1338 53.3438V78.525L93.8963 79.6313C106.046 82.6313 114.315 88.4437 114.315 101.456C114.315 115.575 103.815 123.45 89.1338 124.725ZM68.94 64.9312C68.94 69.6937 71.8838 73.3875 78.2213 75.675C79.1025 76.0312 79.9838 76.3125 81.0338 76.6125V53.3625C74.115 54.2438 68.94 58.125 68.94 64.9312ZM90.7838 90.2812C90.2588 90.1687 89.7338 90.0375 89.1338 89.8687V114.938C97.1213 114.225 102.634 109.837 102.634 102.487C102.634 96.7312 99.6525 92.9812 90.7838 90.2812Z'
        fill='#271B71'
      />
    </svg>
  );
};

export default Money;
